import { render } from "./account-mapping.vue?vue&type=template&id=bcff1eff&scoped=true"
import script from "./account-mapping.vue?vue&type=script&lang=js"
export * from "./account-mapping.vue?vue&type=script&lang=js"

import "./account-mapping.vue?vue&type=style&index=0&id=bcff1eff&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcff1eff"]])

export default __exports__